export default __webpack_public_path__ + "static/media/006-ice cream.ce26187d.svg";